import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=228a68a3"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"
import style0 from "./Course.vue?vue&type=style&index=0&id=228a68a3&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports